<finx-table
  [class.global-table-styling]="isGlobalStylingEnabled"
  [entityData]="entityData"
  [pageSize]="pageSize"
  [pageNumber]="pageNumber"
  [pagingEnabled]="pagingEnabled"
  [totalListCount]="totalListCount"
  [columns]="columns"
  [isSelectedId]="isSelectedId"
  [actionOptions]="actionOptions"
  [isShowOption]="isShowOption"
  [menuPopupCss]="menuPopupCss"
  [isShowMoreOption]="isShowMoreOption"
  (navigateToUrl)="goToLink($event)"
  (options)="moreOption($event)"
  (pageChange)="onPageChange($event)"
  (closeMenuPopPup)="closeMenu()"
  [contentStyle]="contentStyle"
  [emptyTableMsg]="emptyTableMsg"
  [viewPaginationOptions]="viewPaginationOptions"
  [enableSearch]="enableSearch"
  [searchPlaceHolder]="searchPlaceHolder"
  [searchIcon]="searchIcon"
  [currentSearchInputStyle]="currentSearchInputStyle"
  [currentActiveStyle]="currentActiveStyle"
  [currentInactiveStyle]="currentInactiveStyle"
  [searchIconStyle]="searchIconStyle"
  [selectedTableSize]="selectedTableSize"
  [horizontalGridLinesEnabled]="horizontalGridLinesEnabled"
  [verticalGridLinesEnabled]="verticalGridLinesEnabled"
  [tableGridLines]="tableGridLines"
  [tableRowStyle]="tableRowSetting"
  [menuItemsStatus]="menuItemsStatus"
  [multipleSelectionAllowed]="multipleSelectionAllowed"
  (searchTextEmit)="searchValue($event)"
  (checkboxSelection)="emitSelectedItemsIds($event)"
  (tableHeaderCheckboxSelection)="emitSelectedItems($event)"
  [tableHeaderStyles]="tableHeaderStyles"
  [actionButtonContent]="actionButtonContent"
  [confirmButtonStyle]="confirmButtonStyle"
  [dropdownOptions]="dropdownOptions"
  [checkboxStyles]="checkboxStyles"
  (rowData)="onClickRowData($event)"
  (dropDownValue)="onDropdownValue($event)"
  (confirmButtonAction)="onConfirmButtonAction($event)"
  [enableClickableRow]="enableClickableRow"
  [tableHeaderCustomCss]="tableHeaderCustomCss"
  [tableRowCustomCss]="tableRowCustomCss"
  [isApiInProgress]="isApiInProgress"
  [fetchingContent]="fetchingContent"
  [skeletonConfig]="skeletonConfig"
  [tableRowBgColour]="tableRowBgColour"
  [searchInputStyle]="searchInputStyle"
  [tableToolbarHeaderStyle]="tableToolbarHeaderStyle"
  [dropdownAction]="dropdownAction"
  [showConfirmButton]="showConfirmButton"
  [selectedOption]="selectedOption"
  [uniqueId]="uniqueId"
  [totalListDisabled]="totalListDisabled"
  [listActions]="dataIn.attri?.['listActions']"
  (actionEvent)="handleAction($event)"
></finx-table>
